// //שימו לב!! שיטת הפוסטמסג' לא עובדת בשרת מקומי (localhost). חובה להעלות את הקוד שלכם לדומיין שלכם.

//       window.onerror = function (msg, url, line, col, error) {
//           alert("שגיאת תוכנה. פנה לתמיכה טכנית. שגיאה: " + msg)
//       }

//       //זהירות! את השורת קוד הזו יש להפעיל רק פעם אחת בעת פתיחת הדף
//       function onload(num) {
//         debugger;
//           if (window.addEventListener) { window.addEventListener("message", ReadPostMessage, false); } else { window.attachEvent("onmessage", ReadPostMessage); }
//           document.getElementById('NedarimFrame').onload = function () { console.log('StartNedarim'); PostNedarim({'Name':'GetHeight'}) }
//           document.getElementById('NedarimFrame').src = "https://matara.pro/nedarimplus/iframe?language=he"
//           //  +"&mosad=7005642"
//           // "&Amount=" + num
//           // "&ApiValid=7005642" +
//           // "&PaymentType=Ragil" +
//           // "&Email=" + this.clientSer.currentClient.mail +
//           // "&Phone=" + this.clientSer.currentClient.phone +
//           // "&Zeout=" + this.clientSer.currentClient.id +
//           // "&ClientName=" + this.clientSer.currentClient.firstName + ' ' + this.clientSer.currentClient.lastName +
//           // "&City=" + cityName +
//           // "&Street=" + StreetName
//           ;
//       }


//       function PostNedarim(Data) { var iframeWin = document.getElementById('NedarimFrame').contentWindow; iframeWin.postMessage(Data, "*"); };
//       function ReadPostMessage(event) {
//           console.log(event.data);
//           switch (event.data.Name) {
//               case 'Height':
//                   //Here you get the height of iframe | event.data.Value
//                   document.getElementById('NedarimFrame').style.height = (parseInt(event.data.Value) + 15) + "px";
//                   document.getElementById('WaitNedarimFrame').style.display = 'none';
//                   break;

//               case 'TransactionResponse':
//                   document.getElementById('Result').innerHTML = '<b>TransactionResponse:<br/>' + JSON.stringify(event.data.Value) + '</b><br/>see full data in console';
//                   console.log(event.data.Value)
//                   if (event.data.Value.Status == 'Error') {
//                       document.getElementById('ErrorDiv').innerHTML = event.data.Value.Message
//                       document.getElementById('WaitPay').style.display = 'none';
//                       document.getElementById('PayBtDiv').style.display = 'block';
//                   } else {
//                       document.getElementById('WaitPay').style.display = 'none';
//                       document.getElementById('OkDiv').style.display = 'block';
//                   }
//           }
//       }
//       function PayBtClick() {
//           document.getElementById('Result').innerHTML = ''
//           document.getElementById('PayBtDiv').style.display = 'none';
//           document.getElementById('OkDiv').style.display = 'none';
//           document.getElementById('WaitPay').style.display = 'block';
//           document.getElementById('ErrorDiv').innerHTML = '';
//           PostNedarim({
//               'Name': 'FinishTransaction2',
//               'Value': {
//                   'Mosad': document.getElementById('MosadId').value,
//                   'ApiValid': document.getElementById('ApiValid').value,
//                   'PaymentType': document.getElementById("PaymentType").value,
//                   'Currency': '1',

//                   'Zeout': '',
//                   'FirstName': document.getElementById('ClientName').value,
//                   'LastName': '',
//                   'Street': document.getElementById('Street').value,
//                   'City': document.getElementById('City').value,
//                   'Phone': '',
//                   'Mail': '',

//                   'Amount': document.getElementById('Amount').value,
//                   'Tashlumim': '1',

//                   'Groupe': '',
//                   'Comment': 'בדיקת אייפרם 2',

//                   'Param1': 'פרמטר 1',
//                   'Param2': '',
//                   'ForceUpdateMatching': '1', //מיועד לקמפיין אם מעוניינים שהמידע יידחף ליעד, למרות שזה לא נהוג באייפרם

//                   'CallBack': '',

//                   'Tokef': document.getElementById('Tokef').value //אם אתם מנהלים את התוקף בדף שלכם (מיועד למי שרוצה להפריד בין חודש לשנה ורוצה לעצב מותאם אישית)

//               }
//           });
//       }
//       var LastMouseDown
//       var LastMouseUp
//       function RestorePass(Action, Message) {


//           $("#RestorePassDiv").show();
//           $("#LogInAskRestorePass").hide();
//           $("#RestorePassData").html('');



//           if (CheckZeoutJson.RescuePhone !== '') {
//               $("#RestorePassData").append('<b>באמצעות הטלפון:</b><br/>במידה וקו טלפון <span dir="ltr" style="color:cornflowerblue">' + CheckZeoutJson.RescuePhone + '</span> נמצא ברשותכם,<br/><span style="color:cornflowerblue;cursor:pointer;font-weight:600" onclick="RestorePass(\'Phone\')">לחצו כאן</span> לקבלת קוד חדש באמצעות שיחת טלפון.');
//               if (Action == 'Phone' && Message !== undefined) $("#RestorePassData").append('<br />' + Message)
//               if (Action == 'Phone' && Message == undefined) $("#RestorePassData").append('<br/><img src="Files/waitnew.gif" style="width:25px"  />')
//               $("#RestorePassData").append('<br />&nbsp;<br />')
//           }
//           if (CheckZeoutJson.RescueMail !== '') {
//               $("#RestorePassData").append('<b>באמצעות המייל:</b><br/>במידה ומייל <span dir="ltr" style="color:cornflowerblue">' + CheckZeoutJson.RescueMail + '</span> נמצא ברשותכם,<br/><span style="color:cornflowerblue;cursor:pointer;font-weight:600" onclick="RestorePass(\'Email\')">לחצו כאן</span> לקבלת קוד חדש למייל.');
//               if (Action == 'Email' && Message !== undefined) $("#RestorePassData").append('<br />' + Message)
//               if (Action == 'Email' && Message == undefined) $("#RestorePassData").append('<br/><img src="Files/waitnew.gif" style="width:25px"  />')
//               $("#RestorePassData").append('<br />&nbsp;<br />')
//           }

//           $("#RestorePassData").append('<b>באמצעות שרות הלקוחות:</b><br/>ניתן ליצור איתנו קשר באמצעות מייל a037630543@gmail.com<br/>או בטלפון 03-7630543 שלוחה 2<br />&nbsp;<br />');


//           $("#RestorePassData").append('<b>לאחר כניסה למערכת באמצעות הסיסמה הזמנית,<br/>יש להגדיר סיסמה קבועה בתפריט > פרטים אישיים.</b>');

//           if (Action !== undefined && Message == undefined) {
//               $.ajax({
//                   url: "../V6/Files/WebServices/GetClientData.aspx?Action=RestorePassword&Type=" + Action,
//                   type: "POST",
//                   data: "Zeout=" + encodeURIComponent(LogInZeout),
//                   context: Text,
//                   timeout: 10000,
//               }).success(function (data) {
//                   if (data.Result == "Error") {
//                       RestorePass(Action, '<b style="color:indianred">' + data.Message + '</b>')
//                   } else {
//                       $('#LogInTxt').unbind().bind('keyup', function (e) { if ($("#LogInTxt").val().length == 6 || e.keyCode == "13") { Login() } });
//                       $('#LogInTxt').val('').focus()
//                       RestorePass(Action, '<b style="color:green">' + data.Message + '</b>')
//                   }
//               }).error(function () {
//                   RestorePass(Action, '<b style="color:indianred">תקלת תקשורת. נסה שוב</b>')
//               });
//           }
//       }


//       function OpenLogIn(Zeout, BypassFirstLogin) {
//           ClientJson = undefined;
//           $("#LogInDiv").show();
//           $("#LogInTxt,#LogInBt,#NewClientDiv").show();
//           $("#LogInWait,#LogInError,#RestorePassDiv,#LogInAskRestorePass").hide();
//           $("#LogInBt").val('המשך');

//           $("#LogInTxt").attr('type', 'tel').css('-webkit-text-security', 'none');
//           $("#LogInTxt").val(Zeout).attr('placeholder', 'הקלד מספר זהות').focus();
//           $('#LogInTxt').unbind().bind('keyup', function (e) { if ($("#LogInTxt").val().length == 9 || e.keyCode == "13") { Login() } });
//           LogInZeout = ''
//           if (BypassFirstLogin == true) {
//               LogInZeout = Zeout
//               $("#LogInBt").val('אישור');
//               $("#LogInTxt").val('').css('-webkit-text-security', 'disc').attr('placeholder', 'הקלד סיסמה');
//           } else if (Zeout !== '') {
//               Login()
//           };

//       }
//       var LogInZeout
//       var LogInPass
//       var ClientJson
//       var CheckZeoutJson
//       function Login(PopUp) {

//           $("#LogInTxt").focus();
//           $("#LogInTxt,#LogInBt").hide()
//           $("#LogInWait").show()
//           $("#LogInError,#LogInAskRestorePass,#RestorePassDiv").hide()

//           if (LogInZeout == '') {
//               $("#LogInLbl").show();
//               $("#ClientZoneLbl,#ClientFastLogIn").hide();
//               LogInZeout = $("#LogInTxt").val()
//               $.ajax({
//                   url: "../V6/Files/WebServices/CheckZeoutValidity.aspx?Action=CheckZeoutValidityNew",
//                   type: "POST",
//                   data: "Zeout=" + encodeURIComponent(LogInZeout),
//                   context: Text,
//                   timeout: 10000,
//               }).success(function (data) {
//                   CheckZeoutJson = data;
//                   if (data.Result == "Error") {
//                       LogInZeout = ''
//                       $("#LogInError").html(data.Message).show();
//                       return false
//                   }
//                   if (data.ClientType == "New") {
//                       LogInZeout = ''
//                       $("#LogInError").html('אינך רשום במערכות נדרים').show();
//                       return false;
//                   }

//                   if (data.ClientType == "NoPass") { Login(); return false; }
//                   $("#LogInLbl,#NewClientDiv").hide();
//                   $("#ZeoutTxt").val(LogInZeout)
//                   $("#ClientFastLogIn,#LogInAskRestorePass").show();
//                   $("#LogInTxt").val('');
//                   $("#LogInBt").val('אישור');
//                   $("#LogInTxt").attr('type', data.PasswordType).css('-webkit-text-security', 'disc').attr('placeholder', 'הקלד סיסמה');
//                   $('#LogInTxt').unbind().bind('keyup', function (e) { if ($("#LogInTxt").val().length == data.PasswordLength || e.keyCode == "13") { Login() } });
//               }).error(function () {
//                   LogInZeout = ''
//                   $("#LogInError").html('תקלת תקשורת | נסה שוב').show();
//               }).complete(function () {
//                   $("#LogInTxt,#LogInBt").show()
//                   $("#LogInWait").hide()
//                   setTimeout(function () { $("#LogInTxt").focus(); }, 1)
//               });
//               return false;
//           }

//           if (PopUp == true) {
//               $("#LogInDiv").show();
//               $("#LogInTxt,#LogInBt,#LogInAskRestorePass").show()
//               $("#LogInWait").hide()
//               $("#LogInTxt").focus();
//               return false
//           }

//           $.ajax({
//               url: "../V6/Files/WebServices/GetClientData.aspx?Action=GetClientData",
//               type: "POST",
//               data: "Zeout=" + encodeURIComponent(LogInZeout) + "&LastNum=" + encodeURIComponent($("#LogInTxt").val()),
//               context: Text,
//               timeout: 10000,
//           }).success(function (data) {
//               $("#LogInAskRestorePass").show();
//               if (data == '' || data == 'Pass') {
//                   $("#LogInError").html('<b>סיסמה שגויה</b>').show();

//                   return false;
//               }
//               if (data == 'Block') {
//                   $("#LogInError").html('משתמש חסום').show();
//                   return false
//               }
//               if (data == 'Lock') {
//                   $("#LogInError").html('<b>משתמש נעול</b><br/>המתן 15 דקות לפני הניסיון הבא.').show();
//                   return false
//               }
//               if (data == 'NotNumber') {
//                   $("#LogInError").html('נא לרשום סיסמה בספרות בלבד').show();
//                   return false
//               }

//               ClientJson = jQuery.parseJSON(data);
//               DeployClientData()

//               LogInPass = $("#LogInTxt").val()
//               $("#LogInDiv,#LogInLbl,#ClientFastLogIn").hide();
//               $("#ClientChooseCard,#ClientZoneLbl").show();
//               $("#TakanonCb").attr('checked', 'checked');
//               $("#LogInTxt").blur()
//               $('#ClientNameTxt,#ZeoutTxt,#AdresseTxt,#CityTxt,#PhoneTxt,#MailTxt').attr('disabled', 'disabled')
//               if (GetURLParameter('ClientZone') == '1') { OpenClientZone() }
//               //OpenClientZone("ChooseCard", true, 'Pay')
//           }).error(function () {
//               $("#LogInError").html('תקלת תקשורת | נסה שוב').show();
//           }).complete(function () {
//               $("#LogInTxt,#LogInBt").show()
//               $("#LogInWait").hide()
//               setTimeout(function () { $("#LogInTxt").focus().select(); }, 1)
//           });
//           return false;

//       }


//       var CreditCards = [];
//       var Param1, Param2
//       function CloseClientZone() { $("#ClientZoneDiv").hide(); }

//       var Menus = ['ChooseCard', 'ClientData', 'Hk', 'History']
//       var CurrentMenu
//       function OpenClientZone(Menu, ShowOnlyMenu, PassedParam1, PassedParam2) {
//           CurrentMenu = Menu + ShowOnlyMenu
//           Param1 = PassedParam1
//           Param2 = PassedParam2
//           //console.log("Menu:" + Menu + "\n" + "ShowOnlyMenu:" + ShowOnlyMenu + "\n" + "Param1:" + Param1 + "\n" + "Param2:" + Param2)
//           $("#ClientZoneDiv").show();
//           var CloseOnly = false
//           if (Menu !== undefined && ShowOnlyMenu !== true) { if ($("#" + Menu + "Div").css('display') == 'block') CloseOnly = true; }
//           Menus.forEach(function (MenuName) {
//               $("#" + MenuName + "Div").hide();
//               $("#" + MenuName + "Bt").css('background', 'white').show();
//               if (ShowOnlyMenu == true && Menu !== MenuName) { $("#" + MenuName + "Bt").hide() }
//               $("#" + MenuName + "Error").hide();
//           })

//           if (Menu !== undefined && CloseOnly == false) {
//               $("#" + Menu + "Bt").css('background', 'linear-gradient(rgb(166, 171, 175,0) 0%, rgba(166, 171, 175, 0.1) 82%, rgb(166, 171, 175,0.4) 100%)');
//               if (Menu == 'ChooseCard') {
//                   $("#ChooseCardDiv").show();
//                   $("#ChooseCardWait").show();
//                   $("#ChooseCardData").hide()
//                   $("#ChooseCardNew,#NewCardDiv").hide()
//                   $("#ChooseCardInstruction").html('');
//                   $("#ChooseCardError").hide()
//                   if (Param1 == 'UpdateHk') $("#ChooseCardInstruction").html('<b>עדכון כרטיס אשראי להוראת קבע מספר: ' + Param2 + '</br>נא לבחור כרטיס אשראי</b>');
//                   if (Param1 == 'Pay') $("#ChooseCardInstruction").html('לתשלום באמצעות כרטיס שמור, לחץ על הכרטיס הרצוי');

//                   $.ajax({
//                       url: "../V6/Files/WebServices/GetClientData.aspx?Action=GetCreditCards",
//                       type: "POST",
//                       data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID),
//                       context: Text,
//                       timeout: 10000,
//                   }).success(function (Json) {
//                       if (Json.Result == "Error") { $("#ChooseCardError").html(Json.Message).show(); return false; }
//                       CreditCards = Json
//                       DeployCreditCards()
//                       $("#ChooseCardNew").show(500)
//                       $("#ChooseCardData").show(500)
//                   }).error(function () {
//                       $("#ChooseCardError").html('תקלת תקשורת | נסה שוב').show();
//                   }).complete(function () {
//                       $("#ChooseCardWait").hide()
//                   });
//               }
//               if (Menu == 'Hk') {
//                   $("#HkDiv").show();
//                   $("#HkWait").show();
//                   $("#HkData").html('').hide()
//                   $.ajax({
//                       url: "../V6/Files/WebServices/GetClientData.aspx?Action=GetHk",
//                       type: "POST",
//                       data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID),
//                       context: Text,
//                       timeout: 10000,
//                   }).success(function (Json) {
//                       if (Json.Result == "Error") { $("#HkError").html(Json.Message).show(); return false; }
//                       if (Json.length == 0) $("#HkError").html('לא נמצאו הוראות קבע').show();
//                       for (var i = 0; i < Json.length; i++) {
//                           var TempHtml = '<div id="Hk' + i + 'Div" style="border:2px solid #eee;border-radius:5px;padding:10px;text-align:right;position:relative;margin:5px auto;-webkit-user-select:none">\
//                                   <div style="display:inline-block">\
//                                       <div>מוסד: <b>' + Json[i].MosadName + '</b></div>'
//                           if (Json[i].Deleted !== '') {
//                               TempHtml += '<div style="font-weight:bold;color:indianred">הוראה לא פעילה</div>'
//                           }
//                           else {
//                               TempHtml += '<div>חיוב הבא: <b>' + Json[i].NextDate + '</b></div>'
//                           };

//                           TempHtml += '<div>סכום בכל חודש: <b>' + Json[i].Amount + '</b></div>'
//                           if (Json[i].Groupe !== '') TempHtml += '<div>קטגוריה: <b>' + htmlEncode(Json[i].Groupe) + '</b></div>'
//                           if (Json[i].Avour !== '') TempHtml += '<div>הערות: <b>' + htmlEncode(Json[i].Avour) + '</b></div>'
//                           if (Json[i].Deleted == '') TempHtml += '<div>יתרת חיובים: <b>' + Json[i].Tashlumim + '</b></div>'
//                           TempHtml += '<div>בוצעו עד כה: <b>' + Json[i].Success + '</b> חיובים</div>\
//                                       <div>כרטיס אשראי: <b dir="ltr">*******' + Json[i].CardLastNum + '</b></div>\
//                                       <div>תוקף: <b dir="ltr">' + Json[i].Tokef + '</b></div>\
//                                   </div>'
//                           if (Json[i].Deleted == '') TempHtml += '<div id="Hk' + i + 'Bt" style="text-align:left" dir="ltr"><img id="Hk' + i + 'EditBt" src="Files/EditBt.png" style="width:20px;opacity:0.8;cursor:pointer;padding:10px" onclick="$(\'#Hk' + i + 'EditDiv\').show();$(\'#Hk' + i + 'Bt\').hide()" /></div>'
//                           TempHtml += '<div id="Hk' + i + 'DelDiv" style="display:none"><hr/><span style="color:indianred">נא לאשר שליחת בקשה לביטול הוראת הקבע.</span> \
//                           שימו לב! עד טיפול הבקשה ע"י מנהל המוסד, הוראת הקבע לא תחוייב.<br/>\
//                           <div style="text-align:center;margin-top:10px"><input type="button" style="border:0;background-color:#2ed42e;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="אישור" onclick="DeleteHk(' + Json[i].ID + ',' + i + ')" />\
//                           <input type="button" style="border:0;background-color:#c3c3c3;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="ביטול" onclick="$(\'#Hk' + i + 'DelDiv\').hide();$(\'#Hk' + i + 'Bt\').show()" /></div></div>'
//                           TempHtml += '<div id="Hk' + i + 'EditDiv" style="display:none"><hr/><b>עדכון פרטים</b><br/><span>לעדכון סכום, מספר תשלומים וכו\', עליכם לשלוח הודעה למוסד.\
//                                       <br/><br/><b>שינוי כרטיס אשראי</b><br/>לעדכון פרטי אשראי חדשים, <span style="color:cornflowerblue;cursor:pointer" onclick="OpenClientZone(\'ChooseCard\',true,\'UpdateHk\',\'' + Json[i].ID + '\')">לחצו כאן</span> ולאחר מכן יש לבחור את הכרטיס הרצוי.</span> \
//                                       <br/><br/><b>ביטול הוראה</b><br/>לשליחת בקשה לביטול הוראת הקבע, <span style="color:cornflowerblue;cursor:pointer" onclick="$(\'#Hk' + i + 'DelDiv\').show();$(\'#Hk' + i + 'EditDiv\').hide()">לחצו כאן</span>.</span> \
//                                       <div style="text-align:center;margin-top:10px"><input type="button" style="border:0;background-color:#c3c3c3;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="ביטול" onclick="$(\'#Hk' + i + 'EditDiv\').hide();$(\'#Hk' + i + 'Bt\').show()" /></div></div>'
//                           TempHtml += '</div>'
//                           $("#HkData").append(TempHtml);
//                       }
//                       $("#HkData").show(500)
//                   }).error(function (error) {
//                       console.log(error)
//                       $("#HkError").html('תקלת תקשורת | נסה שוב').show();
//                   }).complete(function () {
//                       $("#HkWait").hide()
//                   });
//               }


//               if (Menu == 'ClientData') {

//                   $("#ClientDataZeout,#ClientDataPass1,#ClientDataPass2,#ClientDataClientName,#ClientDataAdresse,#ClientDataCity,#ClientDataPhone,#ClientDataMail").val('')
//                   if (ClientJson == undefined) {
//                       $("#NewClient").show()
//                       $("#ClientDataZeout").val($("#LogInTxt").val())
//                   } else {
//                       $("#NewClient").hide()
//                       $("#ClientDataClientName").val(ClientJson.Name)
//                       $("#ClientDataAdresse").val(ClientJson.Adresse)
//                       $("#ClientDataCity").val(ClientJson.City)
//                       $("#ClientDataPhone").val(ClientJson.Phone)
//                       $("#ClientDataMail").val(ClientJson.Mail)
//                   }

//                   $("#ClientDataDiv").show((ShowOnlyMenu == true ? undefined : 500))
//                   $("#ClientDataWait,#ClientDataError").hide();
//                   $("#ClientDataSave").show()

//               }


//               if (Menu == 'History') {
//                   $("#HistoryDiv").show();
//                   $("#HistoryWait").show();
//                   $("#HistoryData").html('').hide()
//                   $.ajax({
//                       url: "../V6/Files/WebServices/GetClientData.aspx?Action=GetHistory",
//                       type: "POST",
//                       data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID),
//                       context: Text,
//                       timeout: 10000,
//                   }).success(function (HistoryJson) {
//                       if (HistoryJson.Result == "Error") { $("#HistoryError").html(HistoryJson.Message).show(); return false; }
//                       if (HistoryJson.length == 0) $("#HistoryError").html('לא נמצאו עסקאות').show();
//                       for (var i = 0; i < HistoryJson.length; i++) {

//                           var HistoryData = "<div style='border:2px solid #eee;border-radius:5px;padding:10px;text-align:right;position:relative;margin:5px auto;-webkit-user-select:none'>\
//                                   <strong>עבור מוסד: " + HistoryJson[i].MosadName + "</strong><br />"
//                               + "<strong>תאריך: </strong><span dir='ltr'>" + HistoryJson[i].Time + "</span><br /><strong>סכום: </strong><span>" + HistoryJson[i].Amount + "</span>"
//                           if (HistoryJson[i].Canceled == "1") HistoryData += "<strong style='color:red'> מבוטל</strong>"
//                           HistoryData += "<br />"
//                           if (HistoryJson[i].Type == 'הו"ק' || HistoryJson[i].Tashloumim !== '1') {
//                               HistoryData += "<strong>תשלומים: </strong><span>"
//                               if (HistoryJson[i].Type == 'הו"ק') { HistoryData += 'הו"ק' } else { HistoryData += HistoryJson[i].Tashloumim }
//                               HistoryData += "</span><br />"
//                           }
//                           if (HistoryJson[i].Confirmation !== '0000000' && HistoryJson[i].Confirmation !== '') {
//                               HistoryData += "<strong>מס' אישור: </strong><span>" + HistoryJson[i].Confirmation + "</span><br />"
//                           }
//                           if (HistoryJson[i].Groupe !== '') {
//                               HistoryData += "<strong>עבור: </strong><span>" + HistoryJson[i].Groupe + "</span><br />"
//                           }
//                           if (HistoryJson[i].Avour !== '') {
//                               HistoryData += "<strong>הערות: </strong><span>" + HistoryJson[i].Avour + "</span><br />"
//                           }
//                           HistoryData += "<strong>4 ספרות: </strong><span>" + HistoryJson[i].LastNum + "</span><br />"

//                           //if (HistoryJson[i].MosadId !== '' && (_Artsi == '1' || _Reports !== '') && HistoryJson[i].MosadId !== CurrentMosad) {
//                           //    HistoryData += "<div style='text-align:left'>"
//                           //       + "<input type='button' id='HistoryDataMosad" + i + "' value='עבור למוסד זה + הצג הסטוריה' class='NewCardCss' style='background-color:white;margin-top:10px;width:60%;padding:4px;border:2px solid #eee;color:cadetblue;font-weight:normal;font-size:medium' />"
//                           //       + "</div>"
//                           //}

//                           HistoryData += "</div>"


//                           $("#HistoryData").append(HistoryData);

//                           //if (HistoryJson[i].MosadId !== '' && (_Artsi == '1' || _Reports !== '') && HistoryJson[i].MosadId !== CurrentMosad) {
//                           //    (function (i) {
//                           //        $("#HistoryDataMosad" + i).unbind().bind('click', function () {
//                           //            HistoryOnlyThisMosad = true;
//                           //            GetMosadData(HistoryJson[i].MosadId, "History");
//                           //        });
//                           //    })(i);
//                           //}
//                       };


//                       //    var TempHtml = '<div id="Hk' + i + 'Div" style="border:2px solid #eee;border-radius:5px;padding:10px;text-align:right;position:relative;margin:5px auto;-webkit-user-select:none">\
//                       //        <div style="display:inline-block">\
//                       //            <div>מוסד: <b>' + Json[i].MosadName + '</b></div>'
//                       //    if (Json[i].Deleted !== '') {
//                       //        TempHtml += '<div style="font-weight:bold;color:indianred">הוראה לא פעילה</div>'
//                       //    }
//                       //    else {
//                       //        TempHtml += '<div>חיוב הבא: <b>' + Json[i].NextDate + '</b></div>'
//                       //    };

//                       //    TempHtml += '<div>סכום בכל חודש: <b>' + Json[i].Amount + '</b></div>'
//                       //    if (Json[i].Groupe !== '') TempHtml += '<div>קטגוריה: <b>' + htmlEncode(Json[i].Groupe) + '</b></div>'
//                       //    if (Json[i].Avour !== '') TempHtml += '<div>הערות: <b>' + htmlEncode(Json[i].Avour) + '</b></div>'
//                       //    if (Json[i].Deleted == '') TempHtml += '<div>יתרת חיובים: <b>' + Json[i].Tashlumim + '</b></div>'
//                       //    TempHtml += '<div>בוצעו עד כה: <b>' + Json[i].Success + '</b> חיובים</div>\
//                       //            <div>כרטיס אשראי: <b dir="ltr">*******' + Json[i].CardLastNum + '</b></div>\
//                       //            <div>תוקף: <b dir="ltr">' + Json[i].Tokef + '</b></div>\
//                       //        </div>'
//                       //    if (Json[i].Deleted == '') TempHtml += '<div id="Hk' + i + 'Bt" style="text-align:left" dir="ltr"><img id="Hk' + i + 'EditBt" src="Files/EditBt.png" style="width:20px;opacity:0.8;cursor:pointer;padding:10px" onclick="$(\'#Hk' + i + 'EditDiv\').show();$(\'#Hk' + i + 'Bt\').hide()" /></div>'
//                       //    TempHtml += '<div id="Hk' + i + 'DelDiv" style="display:none"><hr/><span style="color:indianred">נא לאשר שליחת בקשה לביטול הוראת הקבע.</span> \
//                       //שימו לב! עד טיפול הבקשה ע"י מנהל המוסד, הוראת הקבע לא תחוייב.<br/>\
//                       //<div style="text-align:center;margin-top:10px"><input type="button" style="border:0;background-color:#2ed42e;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="אישור" onclick="DeleteHk(' + Json[i].ID + ',' + i + ')" />\
//                       //<input type="button" style="border:0;background-color:#c3c3c3;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="ביטול" onclick="$(\'#Hk' + i + 'DelDiv\').hide();$(\'#Hk' + i + 'Bt\').show()" /></div></div>'
//                       //    TempHtml += '<div id="Hk' + i + 'EditDiv" style="display:none"><hr/><b>עדכון פרטים</b><br/><span>לעדכון סכום, מספר תשלומים וכו\', עליכם לשלוח הודעה למוסד.\
//                       //            <br/><br/><b>שינוי כרטיס אשראי</b><br/>לעדכון פרטי אשראי חדשים, <span style="color:cornflowerblue;cursor:pointer" onclick="OpenClientZone(\'ChooseCard\',true,\'UpdateHk\',\'' + Json[i].ID + '\')">לחצו כאן</span> ולאחר מכן יש לבחור את הכרטיס הרצוי.</span> \
//                       //            <br/><br/><b>ביטול הוראה</b><br/>לשליחת בקשה לביטול הוראת הקבע, <span style="color:cornflowerblue;cursor:pointer" onclick="$(\'#Hk' + i + 'DelDiv\').show();$(\'#Hk' + i + 'EditDiv\').hide()">לחצו כאן</span>.</span> \
//                       //            <div style="text-align:center;margin-top:10px"><input type="button" style="border:0;background-color:#c3c3c3;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="ביטול" onclick="$(\'#Hk' + i + 'EditDiv\').hide();$(\'#Hk' + i + 'Bt\').show()" /></div></div>'
//                       //    TempHtml += '</div>'
//                       //    $("#HkData").append(TempHtml);

//                       $("#HistoryData").show(500)
//                   }).error(function (error) {
//                       console.log(error)
//                       $("#HistoryError").html('תקלת תקשורת | נסה שוב').show();
//                   }).complete(function () {
//                       $("#HistoryWait").hide()
//                   });
//               }


//           }
//       }

//       function DeleteHk(KevaId, Index) {
//           $('#Hk' + Index + 'DelDiv').hide()

//           $.ajax({ //מחיקת הוראת קבע
//               url: "../V6/Files/WebServices/GetClientData.aspx?Action=DeleteKeva",
//               type: "POST",
//               data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID) + "&KevaId=" + encodeURIComponent(KevaId),
//               context: Text,
//               timeout: 10000,
//           }).success(function (Json) {
//               if (Json.Result == "Error") {
//                   EAlertConfirm(Json.Message);
//                   $('#Hk' + Index + 'DelDiv').show()
//                   return false;
//               }
//               $('#Hk' + Index + 'Div').prepend('<div style="font-weight:bold;color:indianred">הוראה לא פעילה</div>')
//           }).error(function () {
//               EAlertConfirm('תקלת תקשורת | נסה שוב')
//               $('#Hk' + Index + 'DelDiv').show()
//           });

//       }

//       var ChoosedCard = ''
//       function DeleteChooseCard() {
//           $("#ClientChooseCard").show();
//           $("#DeleteClientChooseCard").hide();
//           $("#CardTxt,#TokefTxt,#CvvTxt").removeAttr('disabled').val('')
//           ChoosedCard = ''
//       }

//       function UpdateClientData() {

//           if ($("#ClientDataPass1").val() !== $("#ClientDataPass2").val()) {
//               $("#ClientDataError").html('הסיסמאות לא תואמות').show()
//               return false;
//           }

//           $("#ClientDataWait").show()
//           $("#ClientDataError,#ClientDataSave").hide()



//           if (ClientJson !== undefined) {
//               $.ajax({
//                   url: "../V6/Files/WebServices/GetClientData.aspx?Action=UpdateClientData",
//                   type: "POST",
//                   data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID)
//                       + "&Name=" + encodeURIComponent($("#ClientDataClientName").val())
//                       + "&Adresse=" + encodeURIComponent($("#ClientDataAdresse").val())
//                       + "&City=" + encodeURIComponent($("#ClientDataCity").val())
//                       + "&Mail=" + encodeURIComponent($("#ClientDataMail").val())
//                       + "&Phone=" + encodeURIComponent($("#ClientDataPhone").val())
//                       + "&NewPass=" + encodeURIComponent($("#ClientDataPass1").val())
//                   ,
//                   context: Text,
//                   timeout: 10000,
//               }).success(function (Json) {
//                   if (Json.Result == "Error") {
//                       $("#ClientDataError").html(Json.Message).show()
//                       return false;
//                   }
//                   OpenClientZone()
//                   ClientJson.Name = $("#ClientDataClientName").val()
//                   ClientJson.Adresse = $("#ClientDataAdresse").val()
//                   ClientJson.City = $("#ClientDataCity").val()
//                   ClientJson.Phone = $("#ClientDataPhone").val()
//                   ClientJson.Mail = $("#ClientDataMail").val()
//                   DeployClientData()
//               }).error(function (error) {
//                   $("#ClientDataError").html('תקלת תקשורת | נסה שוב').show();
//               }).complete(function () {
//                   $("#ClientDataWait").hide()
//                   $("#ClientDataSave").show()
//               });
//           }
//           else {


//               $.ajax({
//                   url: "../V6/Files/WebServices/GetClientData.aspx?Action=NewClient",
//                   type: "POST",
//                   data: "Zeout=" + encodeURIComponent($("#ClientDataZeout").val())
//                       + "&Pass=" + encodeURIComponent($("#ClientDataPass1").val())
//                       + "&Name=" + encodeURIComponent($("#ClientDataClientName").val())
//                       + "&Adresse=" + encodeURIComponent($("#ClientDataAdresse").val())
//                       + "&City=" + encodeURIComponent($("#ClientDataCity").val())
//                       + "&Mail=" + encodeURIComponent($("#ClientDataMail").val())
//                       + "&Phone=" + encodeURIComponent($("#ClientDataPhone").val())
//                   ,
//                   context: Text,
//                   timeout: 10000,
//               }).success(function (Json) {
//                   if (Json.Result == "Error") {
//                       $("#ClientDataError").html(Json.Message).show()
//                       return false;
//                   }
//                   $('#ClientZoneDiv').hide();
//                   OpenLogIn($("#ClientDataZeout").val(), true)
//                   $("#LogInTxt").val($("#ClientDataPass1").val())
//                   Login()
//               }).error(function (error) {
//                   $("#ClientDataError").html('תקלת תקשורת | נסה שוב').show();
//               }).complete(function () {
//                   $("#ClientDataWait").hide()
//                   $("#ClientDataSave").show()
//               });
//           }
//       }
//       function DeployClientData() {
//           $("#ClientNameTxt").val(ClientJson.Name)
//           $("#ZeoutTxt").val(ClientJson.Zeout)
//           $("#AdresseTxt").val(ClientJson.Adresse)
//           $("#CityTxt").val(ClientJson.City)
//           $("#PhoneTxt").val(ClientJson.Phone)
//           $("#MailTxt").val(ClientJson.Mail)
//       }
//       function OpenNewCardDiv() {
//           if ($('#NewCardDiv').css('display') == 'none') {
//               NewCardJson = {}
//               $('#NewCardNumber,#NewCardTokef,#NewCardCvv,#NewCardName').val('');
//               $('#NewCardWait,#NewCardError').hide();
//               $('#NewCardDiv,#NewCardBt,#NewCardNumberDiv').show(500);
//           }
//       }
//       function AddCard() {
//           $('#NewCardWait').show();
//           $('#NewCardBt,#NewCardError').hide();
//           $.ajax({
//               url: "../V6/Files/WebServices/GetClientData.aspx?Action=AddCard",
//               type: "POST",
//               data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID) + "&CardId=" + encodeURIComponent(AddCardJson.CardID)
//                   + "&CardNumber=" + encodeURIComponent($("#NewCardNumber").val()) + "&Tokef=" + encodeURIComponent($("#NewCardTokef").val()) + "&Cvv=" + encodeURIComponent($("#NewCardCvv").val()) + "&CardName=" + encodeURIComponent($("#NewCardName").val()),
//               context: Text,
//               timeout: 30000,
//           }).success(function (Json) {
//               if (Json.Result == "Error") {
//                   $("#NewCardError").html(Json.Message).show(); return false;
//               }
//               if (AddCardJson.CardID !== undefined) {
//                   for (var j = 0; j < CreditCards.length; j++) {
//                       if (CreditCards[j].CardID == AddCardJson.CardID) { CreditCards.splice(j, 1, Json); }
//                   }
//               } else {
//                   CreditCards.unshift(Json)
//               }
//               DeployCreditCards()
//               $('#NewCardDiv').hide();
//               $('#NewCardLbl').html('הוספת כרטיס אשראי חדש');
//               AddCardJson = {};
//           }).error(function (error) {
//               $("#NewCardError").html('תקלת תקשורת | נסה שוב').show();
//           }).complete(function () {
//               $("#NewCardWait").hide()
//               $("#NewCardBt").show()
//           });
//       }

//       var AddCardJson = {}
//       function UpdateCard(Json, Type) {
//           AddCardJson = Json
//           if (Type == 'Edit') $('#NewCardLbl').html('עדכון כרטיס אשראי<br/>' + AddCardJson.CardNumber);
//           if (Type == 'Replace') $('#NewCardLbl').html('החלפת כרטיס אשראי<br/>' + AddCardJson.CardNumber);

//           $('#NewCardLbl').show()

//           $('#NewCardNumber').val('')
//           if (Type == 'Edit') { $('#NewCardNumberDiv').hide() } else { $('#NewCardNumberDiv').show() }
//           if (Type == 'Edit') { $('#NewCardTokef').val(AddCardJson.Tokef) } else { $('#NewCardTokef').val('') }
//           $('#NewCardCvv').val('')
//           $('#NewCardName').val(AddCardJson.NickName)

//           $('#NewCardWait,#NewCardError').hide();
//           $('#NewCardDiv,#NewCardBt').show(500);

//           if (Type == 'Edit') { $('#NewCardTokef').focus().select() } else { $('#NewCardNumber').focus() }
//       }

//       function DeployCreditCards() {
//           var Json = CreditCards
//           $("#ChooseCardData").html('')
//           if (Json.length == 0) { $("#ChooseCardError").html('לא נמצאו כרטיסים שמורים').show(); } else { $("#ChooseCardError").hide() }
//           for (var i = 0; i < Json.length; i++) {
//               var TempHtml = '<div id="Credit' + i + 'BlockDiv" style="border:2px solid #eee;border-radius:5px;padding:10px;text-align:right;position:relative;margin:5px auto;-webkit-user-select:none"><div id="Credit' + i + 'Div" style="' + (Param1 !== undefined ? 'cursor:pointer' : '') + '"><img src="Files/CreditCardBt.png" class="SmallIcon" />\
//                                           <div style="display:inline-block;margin-right:15px"><div dir="ltr" style="font-weight:bold">' + Json[i].CardNumber + '</div><div>תוקף: ' + Json[i].Tokef + '</div>'
//               if (Json[i].NickName !== '') TempHtml += '<div>כינוי: <span style="font-weight:600">' + htmlEncode(Json[i].NickName) + '</span></div>'
//               TempHtml += '</div></div><div id="Credit' + i + 'Bt" style="position:absolute;bottom:0;left:0" dir="ltr"><img src="Files/EditBt.png" style="width:20px;opacity:0.8;cursor:pointer;padding:10px" onclick="$(\'#Credit' + i + 'MainDiv,#Credit' + i + 'EditDiv\').show();$(\'#Credit' + i + 'Bt,#Credit' + i + 'DelDiv\').hide();" /></div>'
//               TempHtml += '<div id="Credit' + i + 'MainDiv" style="display:none;padding-top:10px">\
//                           <hr/>\
//                           <div id="Credit' + i + 'EditDiv">\
//                           <b>עדכון כרטיס</b><br/>מיועד לעדכון תוקף וכינוי.<br/><span style="color:cornflowerblue;cursor:pointer" id="Credit' + i + 'EditLbl">לחץ כאן לעדכון.</span>\
//                           <br/><br/><b>החלפת כרטיס</b><br/>מיועד לשינוי כרטיס אשראי בכל הוראות הקבע שנגבות מהכרטיס הישן. שימו לב! במידה ואינכם מעוניינים להחליף כרטיס בכל הוראות הקבע, עליכם ללחוץ למטה על הוספת כרטיס, ולא להשתמש בלחצן החלפה.<br/><span style="color:cornflowerblue;cursor:pointer" id="Credit' + i + 'ReplaceLbl">לחץ כאן להחלפה.</span>\
//                           <br/><br/><b>מחיקת כרטיס</b><br/>שימו לב! פעולה זו רק תסיר את הכרטיס מהרשימה הזו ולא תשפיע על הוראות קבע שנגבות מכרטיס זה.<br/><span style="color:cornflowerblue;cursor:pointer" onclick="$(\'#Credit' + i + 'DelDiv\').show();$(\'#Credit' + i + 'EditDiv\').hide();">לחץ כאן למחיקה.</span>\
//                           <div style="text-align:center;margin-top:15px"><input type="button" style="border:0;background-color:#c3c3c3;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="ביטול" onclick="$(\'#Credit' + i + 'MainDiv\').hide();$(\'#Credit' + i + 'Bt\').show()" /></div>\
//                           </div>\
//                           <div id="Credit' + i + 'DelDiv"><b style="color:indianred">נא לאשר מחיקת כרטיס אשראי.</b> \
//                           <div style="text-align:center;margin-top:10px"><input id="Credit' + i + 'DelBt" type="button" style="border:0;background-color:#2ed42e;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="אישור"  />\
//                           <input type="button" style="border:0;background-color:#c3c3c3;color:white;font-family:assistant;padding:5px 15px;border-radius:3px;cursor:pointer;font-size:medium" value="ביטול" onclick="$(\'#Credit' + i + 'MainDiv\').hide();$(\'#Credit' + i + 'Bt\').show()" /></div></div></div>'
//               TempHtml += '</div>'
//               $("#ChooseCardData").append(TempHtml);
//               (function (i) {
//                   $("#Credit" + i + "EditLbl").unbind().bind('click', function () {
//                       UpdateCard(Json[i], 'Edit'); $('#Credit' + i + 'MainDiv').hide(); $('#Credit' + i + 'Bt').show()
//                   });
//                   $("#Credit" + i + "ReplaceLbl").unbind().bind('click', function () {
//                       UpdateCard(Json[i], 'Replace'); $('#Credit' + i + 'MainDiv').hide(); $('#Credit' + i + 'Bt').show()
//                   });
//                   $("#Credit" + i + "Div").unbind().bind('click', function () {
//                       ChoosedCard = ClientJson.SessionId + '|' + ClientJson.SessionPass + "|" + Json[i].CardID + '|' + Json[i].CardHash;
//                       if (Param1 == 'UpdateHk') { //עדכון כרטיס אשראי של הוראת קבע
//                           $.ajax({
//                               url: "../V6/Files/WebServices/GetClientData.aspx?Action=UpdateKevaCard",
//                               type: "POST",
//                               data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID) + "&ChoosedCard=" + encodeURIComponent(ChoosedCard) + "&KevaId=" + encodeURIComponent(Param2),
//                               context: Text,
//                               timeout: 10000,
//                           }).success(function (Json) {
//                               if (Json.Result == "Error") { EAlertConfirm(Json.Message); return false }
//                               IAlertConfirm("הוראת הקבע עודכנה בהצלחה")
//                               OpenClientZone('Hk')
//                           }).error(function () {
//                               $("#ChooseCardError").html('תקלת תקשורת | נסה שוב').show();
//                           }).complete(function () {
//                               $("#ChooseCardWait").hide()
//                           });
//                       } else if (Param1 == 'Pay') {          //בחירת כרטיס אשראי עבור תשלום
//                           $("#CardTxt").val(Json[i].CardNumber)
//                           $("#TokefTxt").val(Json[i].Tokef)
//                           $("#CvvTxt").val('***')
//                           $("#CardTxt,#TokefTxt,#CvvTxt").attr('disabled', 'disabled')
//                           CloseClientZone();
//                           $("#ClientChooseCard").hide();
//                           $("#DeleteClientChooseCard").show();
//                       }
//                   });
//                   $("#Credit" + i + "DelBt").unbind().bind('click', function () {
//                       $("#Credit" + i + "BlockDiv").hide()
//                       var CardId = Json[i].CardID
//                       $.ajax({ //מחיקת כרטיס אשראי
//                           url: "../V6/Files/WebServices/GetClientData.aspx?Action=DeleteCard",
//                           type: "POST",
//                           data: "SessionId=" + encodeURIComponent(ClientJson.SessionId) + "&SessionPass=" + encodeURIComponent(ClientJson.SessionPass) + "&ClientId=" + encodeURIComponent(ClientJson.ID) + "&CardId=" + encodeURIComponent(CardId),
//                           context: Text,
//                           timeout: 10000,
//                       }).success(function (Json) {
//                           if (Json.Result == "Error") {
//                               EAlertConfirm(Json.Message);
//                               $("#Credit" + i + "BlockDiv").show()
//                               return false;
//                           }
//                           for (var j = 0; j < CreditCards.length; j++) {
//                               if (CreditCards[j].CardID == CardId) CreditCards.splice(j, 1);
//                           }
//                       }).error(function () {
//                           EAlertConfirm('תקלת תקשורת | נסה שוב')
//                           $("#Credit" + i + "BlockDiv").show()
//                       });
//                   });
//               })(i);
//           }

//       }


/* SmtpJS.com - v3.0.0 */
// var Email = { send: function (a) { return new Promise(function (n, e) { a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send"; var t = JSON.stringify(a); Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) { n(e) }) }) }, ajaxPost: function (e, n, t) { var a = Email.createCORSRequest("POST", e); a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () { var e = a.responseText; null != t && t(e) }, a.send(n) }, ajax: function (e, n) { var t = Email.createCORSRequest("GET", e); t.onload = function () { var e = t.responseText; null != n && n(e) }, t.send() }, createCORSRequest: function (e, n) { var t = new XMLHttpRequest; return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest).open(e, n) : t = null, t } };
var Email = { send: function (a) { return new Promise(function (n, e) { a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send"; var t = JSON.stringify(a); Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) { n(e) }) }) }, ajaxPost: function (e, n, t) { var a = Email.createCORSRequest("POST", e); a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () { var e = a.responseText; null != t && t(e) }, a.send(n) }, ajax: function (e, n) { var t = Email.createCORSRequest("GET", e); t.onload = function () { var e = t.responseText; null != n && n(e) }, t.send() }, createCORSRequest: function (e, n) { var t = new XMLHttpRequest; return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest).open(e, n) : t = null, t } };


//שימו לב!! שיטת הפוסטמסג' לא עובדת בשרת מקומי (localhost). חובה להעלות את הקוד שלכם לדומיין שלכם.

window.onerror = function (msg, url, line, col, error) {
    alert("שגיאת תוכנה. פנה לתמיכה טכנית. שגיאה: " + msg)
}

//זהירות! את השורת קוד הזו יש להפעיל רק פעם אחת בעת פתיחת הדף
 function onload() {
  debugger;
    if (window.addEventListener) { window.addEventListener("message", ReadPostMessage, false); } else { window.attachEvent("onmessage", ReadPostMessage); }
    document.getElementById('NedarimFrame').onload = function () { console.log('StartNedarim'); PostNedarim({'Name':'GetHeight'}) }
    document.getElementById('NedarimFrame').src = "https://matara.pro/nedarimplus/iframe?language=he";
}


function PostNedarim(Data) { var iframeWin = document.getElementById('NedarimFrame').contentWindow; iframeWin.postMessage(Data, "*"); };
function ReadPostMessage(event) {
    console.log(event.data);
    debugger;
    // return event.data.Name;
    switch (event.data.Name) {
        case 'Height':
            //Here you get the height of iframe | event.data.Value
            document.getElementById('NedarimFrame').style.height = (parseInt(event.data.Value) + 15) + "px";
            document.getElementById('WaitNedarimFrame').style.display = 'none';
            break;
        case 'TransactionResponse':
            document.getElementById('Result').innerHTML = '<b>TransactionResponse:<br/>' + JSON.stringify(event.data.Value) + '</b><br/>see full data in console';
            console.log(event.data.Value)
            if (event.data.Value.Status == 'Error') {
                // document.getElementById('ErrorModel').innerText = event.data.Value.Message
                // document.getElementById('ErrorModel').style.display = 'block';
                this.modalService.open(ErrorModel, { size: 'xl' });


                // document.getElementById('WaitPay').style.display = 'none';
                // document.getElementById('PayBtDiv').style.display = 'block';
            } else {
                document.getElementById('WaitPay').style.display = 'none';
                document.getElementById('OkDiv').style.display = 'block';
            }
    }
}
function PayBtClick() {
  debugger;
  console.log(window.location.pathname);

    document.getElementById('Result').innerHTML = ''
    document.getElementById('PayBtDiv').style.display = 'none';
    document.getElementById('OkDiv').style.display = 'none';
    document.getElementById('WaitPay').style.display = 'block';
    document.getElementById('ErrorDiv').innerHTML = '';
    return PostNedarim({
        'Name': 'FinishTransaction2',
        'Value': {

            'Mosad': '7005642',
            'ApiValid': 'l/WddqgUpf',
            'PaymentType': 'Ragil',
            'Currency': '1',

            'Zeout': '',
            'FirstName':'',
            'LastName': '',
            'Street': '',
            'City': '',
            'Phone': '0583221203',
            'Mail': 'ravcevel@gmail.com',

            'Amount': '1',
            'Tashlumim': '1',

            'Groupe': '',
            'Comment': 'בדיקת אייפרם 2',

            'Param1': 'פרמטר 1',
            'Param2': '',
            'ForceUpdateMatching': '1', //מיועד לקמפיין אם מעוניינים שהמידע יידחף ליעד, למרות שזה לא נהוג באייפרם

            'CallBack': '',

            'Tokef': ''

        }
    });
}
